export default __webpack_public_path__ + "static/media/craft.5e896e99.svg";